import { WordForms } from '@shared/lib';
import invitationStatusesStyles from './invitation-statuses.module.scss';

export const pageSize = 10;

export const NO_DATA = 'NO_DATA';

export const MARITAL_STATUS_MAP: Record<string, string> = {
  NOT_MARRIED: 'не в браке',
  MARRIED: 'в браке',
  DIVORCED: 'разведен',
};

export const COUNT_CHILDREN_MAP: Record<string, string> = {
  NO_CHILDREN: 'детей нет',
  1: 'детей - 1',
  2: 'детей - 2',
  3: 'детей - 3',
  4: 'детей - 4',
  '5_AND_MORE': 'детей - больше 5',
};

export const ORDER_NAME_MAP: Record<string, string> = {
  clientInfo: 'NAME',
  salesManager: 'MANAGER',
  brokers: 'BROKER',
  projects: 'DEALS_SUMM',
  invitation: 'INVITATION',
  reconfirmationStatus: 'RECONFIRMATION_STATUS',
  additionalGuest: 'ADDITIONAL_GUEST',
  checked: 'PRESENCE',
};

export const INVITATION_STATUSES = [
  {
    value: 'REJECTED',
    label: 'Отказ',
    className: invitationStatusesStyles.rejected,
  },
  {
    value: 'CONFIRMED',
    label: 'Подтверждено',
    className: invitationStatusesStyles.confirmed,
  },
  {
    value: 'WAITING',
    label: 'Ожидает подтверждения',
    className: invitationStatusesStyles.waiting,
  },
];

export const RECONFIRMATION_STATUSES = [
  {
    value: 'REJECTED',
    label: 'Отказ накануне',
    className: invitationStatusesStyles.rejected,
  },
  {
    value: 'CONFIRMED',
    label: 'Повторно подтверждено',
    className: invitationStatusesStyles.confirmed,
  },
  {
    value: 'WAITING',
    label: 'Ожидает подтверждения',
    className: invitationStatusesStyles.waiting,
  },
  {
    value: 'SENT',
    label: 'Подтверждение направлено',
    className: invitationStatusesStyles.sent,
  },
];

export const PRESENCE_STATUSES = [
  {
    value: 'false',
    label: 'Нет',
    className: invitationStatusesStyles.presenceNo,
  },
  {
    value: 'true',
    label: 'Да',
    className: invitationStatusesStyles.presenceYes,
  },
];

export const ADD_CLIENT_TABS = ['Клиенты', 'Импортировать из Excel'];

export const participantForms: WordForms = {
  one: 'участник',
  few: 'участника',
  many: 'участников',
};

export const MIN_AGE_PARTICIPANT = 0;
export const MAX_AGE_PARTICIPANT = 100;

export const MIN_DEAL_SUM_PARTICIPANT = 0;
export const MAX_DEAL_SUM_PARTICIPANT = 100_000_000_000;
export const DEAL_SUM_MILLION = 1_000_000;

export const SEARCH_MIN_LENGTH = 3;
export const FILTER_DEBOUNCE_MS = 1500;

export type TriStateFilterValue = boolean | null;

export const BROKER_FILTER_OPTIONS: { value: TriStateFilterValue; label: string }[] = [
  { value: true, label: 'Есть' },
  { value: false, label: 'Нет' },
  { value: null, label: 'Неважно' },
];

export const DO_NOT_CALL_FILTER_OPTIONS: { value: TriStateFilterValue; label: string }[] = [
  { value: true, label: 'Да' },
  { value: false, label: 'Нет' },
  { value: null, label: 'Неважно' },
];
